<template>
  <!-- 合并弹框 -->
  <a-modal v-model:visible="modal.visible" :afterClose="close" :maskClosable="false" title="创建标注合并任务"  width="750px">
    <a-form :model="form.mergeForm" ref="formRef" :colon="false" :rules="taskFormRules" labelAlign="right" :labelCol="{span: 5, offset: 1}">
      <a-form-item label="关联数据集名称" name="datasetId">
        <!-- <a-input style="width: 200px" v-model:value="form.mergeForm.datasetId" autocomplete="off"></a-input> -->
        {{form.mergeForm.dataset.chineseInstructions  }}
      </a-form-item>
      <a-form-item label="标注合并任务名称" name="name" props="name">
        <a-input style="width: 300px"  placeholder="请输入内容" v-model:value="form.mergeForm.name" autocomplete="off"></a-input>
      </a-form-item>
      <a-form-item label="说明" name="description">
        <a-textarea style="width: 500px;" v-model:value="form.mergeForm.description" placeholder="请输入内容" :rows="3" />
      </a-form-item>
    
      <div class="mt30 mb10">选择需要标注信息合并任务</div>
      <a-form-item label="">
        <a-form layout="inline" ref="searchForm" :model="form.searchForm" style="margin-bottom: 20px;">
          <a-form-item label="">
            <a-input style="width: 300px" placeholder="根据数据标注任务总任务编号/名称查询" v-model:value="form.searchForm.keyword"></a-input>
          </a-form-item> 
          <a-form-item label="">
            <a-button type="primary" @click="search">查询</a-button>
          </a-form-item> 
        </a-form>
        <a-table :dataSource="form.searchForm.mergeList"  :scroll="{ x: 1500, y: 300 }" :columns="columns" :pagination="false">
          <template #number="{ record }">
            <span  v-if="record.isParent">
              {{ record.number }}
            </span>
            <span v-else> 
              <a-checkbox v-model:checked="record.checked"  />
             {{ record.number }}
            </span> 
           
          </template>
          <template v-slot:type="{ record }">
            {{type[record.type]}}
          </template>
          <template v-slot:state="{ record }">
            {{taskSatus[record.state]}}
          </template>
        </a-table>
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button key="back" @click="modal.visible = false">取消</a-button>
      <a-button key="submit" type="primary" :loading="modal.loading" @click="handleOk">确认合并</a-button>
    </template>
  </a-modal>

</template>
<script>

import { message } from 'ant-design-vue';

import{ref,reactive,watch, onMounted,computed} from 'vue'

import { useStore } from '@/store/index2'

import { useRouter } from 'vue-router'


import {datasetTasks, mergeCreate} from '@/api/taskRelease'



   
const columns = [
  {
    title: '任务编号',
    dataIndex: 'number',
    slots:{customRender:'number'}
  },
  {
    title: '任务名称',
    dataIndex: 'name'
  },

  {
    title: '任务类型',
    dataIndex: 'type',
    slots: { customRender: 'type' }
  },

  {
    title: '任务状态',
    dataIndex: 'state',
    slots: { customRender: 'state' }
   
  },

]
  
export default {
  props:['show','labelTaskSubId'],


  emits: ['close','update'],
  setup(props,context){
    const formRef = ref()
 
    let router = useRouter()

    let store = useStore()
    let type = store.taskType
    let taskSatus = store.taskSatus

     /* 弹框交互    */
   let modal = reactive({
      visible:props.show,
      loading:false,
    })


    let form = reactive({
      mergeForm:{
        dataset:{

        },
        description:'',
        name:'',
        groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
        labelTaskSubIds:[],
        name:'',

      },
      searchForm:{
        keyword:'',
        mergeList:[],
        mergeListOrign:[],
        page: {
          pageNum: 1,
          pageSize: 30
        },
      }
    })

    


    function handleCancel(){
      modal.visible = false
    }

    
    function close(){
      context.emit('close')
    }

    const plainOptions = ['Apple', 'Pear', 'Orange'];
     //获取数据集
    async function getDatasetTasks(labelTaskSubId){ 
      const {data:res} = await datasetTasks(labelTaskSubId)
      if(res.code == 0){
        form.searchForm.mergeList = [...res.data.labelTasks]
        form.searchForm.mergeList.forEach((item)=>{
          item.isParent = true
         
          item.children.forEach((child)=>{
            child.checked = false
          })

          // if(item.children.length == 0){
          //   delete item.children
          // }
        })

        form.searchForm.mergeListOrign = [...form.searchForm.mergeList]
      
        form.mergeForm.dataset = res.data.dataset
      }else{
        message.error(res.msg)
      }
    }


    const taskFormRules = {
      name: [
        {
          required: true,
          message: '任务名称不能为空',
          trigger: 'blur',
        }
      ],
    }
    

    function search(){
      let keyword = form.searchForm.keyword
      debugger
      if(keyword){
        let arr = form.searchForm.mergeList.filter((item)=>{
          return (item.name == keyword || item.number == keyword)
        })  
        form.searchForm.mergeList = arr
      }else{
        form.searchForm.mergeList = [...form.searchForm.mergeListOrign]
      }
     
    }
      
     function handleOk(){      
      formRef.value
      .validate()
      .then(async () => {
          modal.loading = true
          let data = {
            datasetId:form.mergeForm.dataset.id,
            description:form.mergeForm.description,
            name:form.mergeForm.name,
            groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
            labelTaskSubIds:[],
          }

          

          form.searchForm.mergeList.forEach((item)=>{
            item.children.forEach((child)=>{
              if(child.checked){
                data.labelTaskSubIds.push(child.id)
              }          
            })
          }) 
    

       
          const {data:res} = await mergeCreate(data)
          
          if(res.code == '0'){
            close()
            message.success(res.msg)
            modal.visible = false
            router.push('/mergeList')
          }else{
            message.error(res.msg)
          }

          modal.loading = false

      })
    }  


    onMounted(()=>{
      getDatasetTasks(props.labelTaskSubId)
   
    })

    return {
      columns,
      modal,
      type,
      taskSatus,
      handleCancel,
      close,  

      taskFormRules,
      formRef,
      form,

      getDatasetTasks,
      handleOk,
      plainOptions,
      search,
    }
  }   
}
</script>
<style lang="less">
.select_he{
  height: 150px;
  overflow-y: auto;
}
// .rc-virtual-list-holder-inner{
//   max-height: 200px;
//   overflow: auto;
// }
.itemInfo{
  border:1px solid #ccc;
  padding:15px;
  margin-top: 5px;
  dl{
    display: flex;
    align-items: center;
    height: 25px;
    dt{
      margin-right: 5px;
    }
    dd{
      margin-top: 7px;
    }
  }
}
</style>
